/**
 * Messages between the AGC node and its AudioWorklet (design §7.4.1).
 *
 * @module
 */
export const AGC_PROCESSOR = "avgv-agc";

export type AgcPresetName = "speech" | "gentle" | "limit";

export interface AgcProcessorOptions {
  wasm: ArrayBuffer;
  channels: number;
}

export type AgcMessage =
  | { type: "enabled"; enabled: boolean }
  | { type: "preset"; preset: AgcPresetName }
  | { type: "target"; dbfs: number };

/** From the worklet, about ten times a second. */
export interface AgcReport {
  type: "gain";
  db: number;
}
